export default [
    {
        id: 'create-geo-record-polygon',
        type: 'fill',
        source: 'creating-geo-record',
        paint: {
            'fill-color': '#ffff00',
            'fill-opacity': 0.6,
        },
        filter: ['all', ['==', ['geometry-type'], 'Polygon']],
    },
    {
        id: 'create-geo-record-linestring',
        type: 'line',
        source: 'creating-geo-record',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-width': 1,
            'line-color': '#ffff00',
        },
        filter: ['==', ['geometry-type'], 'LineString'],
    },
    {
        id: 'create-geo-record-points',
        type: 'circle',
        source: 'creating-geo-record',
        paint: {
            'circle-radius': 4,
            'circle-color': '#ffff00',
        },
        filter: ['==', ['geometry-type'], 'Point'],
    },
    {
        id: 'create-geo-record-extrusion',
        type: 'fill-extrusion',
        source: 'creating-geo-record',
        paint: {
            'fill-extrusion-color': '#ffff00',
            'fill-extrusion-height': ['get', 'height'],
            'fill-extrusion-opacity': 0.6,
        },
        filter: [
            'all',
            ['==', ['geometry-type'], 'Polygon'],
            ['==', ['get', 'isVisible'], true],
        ],
    },
];
